export default {
  title: 'my profile',
  title_other: "{{name}}'s profile",
  form: {
    avatar: 'Update photo',
  },
  avatar: {
    title: 'Crop your profile picture',
    alt: 'original image',
    form: {
      submit: 'Save picture',
    },
  },
  settings: {
    title: 'Your profile preferences',
    form: {
      name: 'Full name',
      boulderScale: 'Bloc grading scale',
      routeScale: 'Climbing grading scale',
      no_scale: "Keep the spot's scale",
      submit: 'Update profile',
      notifications: 'Notifications',
      notifyRoute: 'get notification when a new route is settled',
      notifyComment: 'get notification when someone rate a route',
      suggestRoute: 'display suggestion for new routes',
    },
    formHelper: {
      notifyRoute: 'Receive an email when a new route is settled in the spot',
      notifyComment: 'Receive an email when somebody tick a route in the spot',
      suggestRoute: 'When I tik a route, suggest me similar routes',
    },
    tabs: {
      stats: 'Ascents',
      profile: 'Settings',
    },
  },
  notifications: {
    confirm: {
      title: 'Please confirm notification deactivation',
      alert: 'You can restore the original configuration in the "my profile" menu.',
      submit: 'Deactivate',
    },
  },
  tooltip: {
    admin: 'deletion not allowed: admin member of the spot',
  },
  stats: {
    graphs: {
      empty: {
        title: 'No data to display',
        body: 'Go to the topo, tick routes and follow your progress.',
        button: 'See the topo',
      },
      tick: 'tick distribution',
      count_by_grade: 'tick by grade',
      count_by_date: 'tick history',
      grade_by_date: 'max grade history',
    },
    summary: {
      grade: 'max level',
      liked: '❤️',
      comments: 'tikcs',
    },
    select: {
      day: '30 days',
      month: '1 year',
      year: 'everything',
    },
  },
  delete: {
    title: 'Delete my account',
    description: 'Once you delete your account, there is no going back. Please be certain.',
    button: 'Delete my account',
    confirm: {
      title: 'Are you absolutely sure?',
      warning: 'Warning',
      helper: 'This action cannot be undone. This will permanently delete your account, and your comments.',
      submit: 'Delete my account',
    },
  },
}
